/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-10-19 11:19:50
 */
import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { isPlat } from '@/assets/js/authType';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { MainTableFields as tf } from '../../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '运营公司',
            dataIndex: 'targetName',
            key: 'targetName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: 'recTime',
            key: 'recTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => {
                return <p>
                    <span>{record.startTime ? moment(record.startTime).format('YYYY-MM-DD') : '' }</span>~
                <span>{record.endTime ? moment(record.endTime).format('YYYY-MM-DD') : ''}</span></p>
            }
        },
        {
            title: '对账金额（元）',
            dataIndex: 'settleAmount',
            key: 'settleAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'verifyStatusName',
            key: 'verifyStatusName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '生成时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.big,
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _takeColumnsB = () => ([
        {
            title: '运营公司',
            dataIndex: 'targetName',
            key: 'targetName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: 'recTime',
            key: 'recTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => {
                return <p>
                    <span>{record.startTime ? moment(record.startTime).format('YYYY-MM-DD') : '' }</span>~
                <span>{record.endTime ? moment(record.endTime).format('YYYY-MM-DD') : ''}</span></p>
            }
        },
        {
            title: '对账金额（元）',
            dataIndex: 'settleAmount',
            key: 'settleAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'verifyStatusName',
            key: 'verifyStatusName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '是否对区域运营商呈现',
            dataIndex: 'isAppear',
            key: 'isAppear',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text)=><div>{text==0?'不呈现':'呈现'}</div>
        },
        {
            title: '生成时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.big,
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>  
                <div className={styles.item} onClick={() => tableAction(key, 'detail')}>详情</div>
                {isPlat() && record.opType==='MANUAL' && <div className={styles.item} onClick={() => tableAction({id:key,isAppear:record.isAppear==0?1:0}, 'isAppear')}>{record.isAppear==0?'呈现':'不呈现'}</div>}
                { isPlat() ? record.verifyStatus == 'CONFIRM_SUCCESS' && <div className={styles.item} onClick={() => tableAction(key, 'pay')}>手工打款</div> :
                record.verifyStatus == 'TO_CONFIRM' && <div className={styles.item} onClick={() => tableAction(key, 'sureAccount')}>确认对账单</div>}
                
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record, index) => record.id}
                    columns={isPlat()?this._takeColumnsB():this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;